const Breadcrumbs     = () => import('vue-cl/components/Breadcrumbs');
const CardLink        = () => import('vue-cl/components/CardLink');
const CrRecordset     = () => import('vue-cl/components/CrRecordset');
// const ColorPicker     = () => import('vue-cl/components/ColorPicker');
const DataTable       = () => import('vue-cl/components/DataTable');
const DebugPanel      = () => import('vue-cl/components/DebugPanel');
const DeltaPercentage = () => import('vue-cl/components/DeltaPercentage');
const DisplayTable    = () => import('vue-cl/components/DisplayTable');
const DisplayTableRow = () => import('vue-cl/components/DisplayTableRow');
const FileTable       = () => import('vue-cl/components/FileTable');
const InfoField       = () => import('vue-cl/components/InfoField');
const Loader          = () => import('vue-cl/components/Loader');
const LoadingModal    = () => import('vue-cl/components/LoadingModal');
const Pager           = () => import('vue-cl/components/Pager');
const RouterLinkCard  = () => import('vue-cl/components/RouterLinkCard');
const SearchBox       = () => import('vue-cl/components/SearchBox');
const SectionHeader   = () => import('vue-cl/components/SectionHeader');
const SortBox         = () => import('vue-cl/components/SortBox');
const Sorter          = () => import('vue-cl/components/Sorter');
const TableReport     = () => import('vue-cl/components/TableReport');
const TableReportRow  = () => import('vue-cl/components/TableReportRow');
const Tag             = () => import('vue-cl/components/Tag');
const TagList         = () => import('vue-cl/components/TagList');
const TimeoutChecker  = () => import('vue-cl/components/TimeoutChecker');

function install(Vue) {
  if (install.installed) return;

  install.installed = true;

  Vue.component('breadcrumbs'      , Breadcrumbs);
  Vue.component('card-link'        , CardLink);
  Vue.component('cr-recordset'     , CrRecordset);
  // Vue.component('color-picker'     , ColorPicker);
  Vue.component('data-table'       , DataTable);
  Vue.component('debug-panel'      , DebugPanel);
  Vue.component('delta-percentage' , DeltaPercentage);
  Vue.component('display-table'    , DisplayTable);
  Vue.component('display-table-row', DisplayTableRow);
  Vue.component('file-table'       , FileTable);
  Vue.component('info-field'       , InfoField);
  Vue.component('loader'           , Loader);
  Vue.component('loading-modal'    , LoadingModal);
  Vue.component('pager'            , Pager);
  Vue.component('router-link-card' , RouterLinkCard);
  Vue.component('search-box'       , SearchBox);
  Vue.component('section-header'   , SectionHeader);
  Vue.component('sort-box'         , SortBox);
  Vue.component('sorter'           , Sorter);
  Vue.component('table-report'     , TableReport);
  Vue.component('table-report-row' , TableReportRow);
  Vue.component('tag'              , Tag);
  Vue.component('tag-list'         , TagList);
  Vue.component('timeout-checker'  , TimeoutChecker);
}

export default {
  install
};
